<template>
	<div class="flex flex-col justify-center items-center w-dvw min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom)">
		<span class="flex text-5xl md:text-7xl w-full justify-center text-center py-8">Wedding Party</span>
		<Divider class="w-32! mt-0!" />

		<div class="hidden md:grid grid-rows-5 grid-cols-4 justify-center items-center w-full gap-y-4">
			<div class="flex flex-col items-center justify-center w-full gap-1 row-span-1 col-span-full">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-semibold!">Officiant</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Hayden Schmidt</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-span-1 col-span-2 col-start-1">
				<span class="text-3xl lg:text-4xl flex w-full justify-center items-center font-semibold! underline underline-offset-4 row-span-1 col-span-2 col-start-1 mb-1">Bride</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Brennan Gonzalez</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-3 col-span-1">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Matron of Honor</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Ayden Penso</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-3 col-span-1">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Maid of Honor</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Haley Walters</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-4 col-span-2">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Bridesmaids</span>
				<div class="flex flex-wrap items-center justify-center w-full gap-x-16">
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Jordan Wheeler</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.alt"
							/>
							<img
								v-else
								class="object-contain size-24 rounded-full"
								:src="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Kirby Six</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Lydia Gonzalez</span>
					</div>
				</div>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-5 col-span-1">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Mother</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex text-center justify-center font-extralight! text-xl">Lisa Schmidt</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-5 col-span-1">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Father</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex text-center justify-center font-extralight! text-xl">Edwin (Chip) Schmidt</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-span-1 col-span-2 col-start-3">
				<span class="text-3xl lg:text-4xl flex w-full justify-center items-center font-semibold! underline underline-offset-4 mb-1">Groom</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Grant Gonzalez</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-3 col-span-2 col-start-3">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Best Man</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Evan Bologa</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-4 col-span-2 col-start-3">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Groomsmen</span>
				<div class="flex flex-wrap items-center justify-center w-full gap-x-16">
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Joe Kirk</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Nick Swinney</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Jack Gonzalez</span>
					</div>
				</div>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-5 col-span-1 col-start-3">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Mother</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex text-center justify-center font-extralight! text-xl">Roselea (Rosie) Gonzalez</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1 row-start-5 col-span-1 col-start-4">
				<span class="text-2xl lg:text-3xl flex w-full justify-center font-bold!">Father</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex text-center justify-center font-extralight! text-xl">David (Alex) Gonzalez</span>
			</div>
		</div>
		<div class="flex md:hidden flex-col items-center justify-center w-full gap-6 row-start-6 col-span-1 pt-8">
			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-semibold!">Officiant</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Hayden_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Hayden Schmidt</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-3xl flex w-full justify-center items-center font-semibold! underline underline-offset-4">Bride</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Brennan_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Brennan Gonzalez</span>
			</div>
			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Matron of Honor</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Ayden_Penso')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Ayden Penso</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Maid of Honor</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Haley_Walters')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Haley Walters</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-4">
				<span class="text-2xl flex w-full justify-center font-bold!">Bridesmaids</span>
				<div class="flex flex-col items-center justify-center gap-1 min-w-30">
					<div
						v-if="!contentLoaded"
						class="size-24 items-center justify-center"
					>
						<LoadingCard
							:show-loading-text="false"
							height="full"
							class="size-24 rounded-full shrink-0"
						/>
					</div>
					<div v-else>
						<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
						<NuxtImg
							v-if="ALLOW_API_CALLS"
							class="object-cover size-24 rounded-full shrink-0"
							provider="imagekit"
							:src="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.alt"
						/>
						<img
							v-else
							class="object-contain w-40 max-h-80 rounded-lg"
							:src="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Jordan_Wheeler')!]?.alt"
						>
					</div>
					<span class="font-extralight! text-xl">Jordan Wheeler</span>
				</div>
				<div class="flex flex-col items-center justify-center gap-1 min-w-30">
					<div
						v-if="!contentLoaded"
						class="size-24 items-center justify-center"
					>
						<LoadingCard
							:show-loading-text="false"
							height="full"
							class="size-24 rounded-full shrink-0"
						/>
					</div>
					<div v-else>
						<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
						<NuxtImg
							v-if="ALLOW_API_CALLS"
							class="object-cover size-24 rounded-full shrink-0"
							provider="imagekit"
							:src="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.alt"
						/>
						<img
							v-else
							class="object-contain size-24 rounded-full"
							:src="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Kirby_Six')!]?.alt"
						>
					</div>
					<span class="font-extralight! text-xl">Kirby Six</span>
				</div>
				<div class="flex flex-col items-center justify-center gap-1 min-w-30">
					<div
						v-if="!contentLoaded"
						class="size-24 items-center justify-center"
					>
						<LoadingCard
							:show-loading-text="false"
							height="full"
							class="size-24 rounded-full shrink-0"
						/>
					</div>
					<div v-else>
						<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
						<NuxtImg
							v-if="ALLOW_API_CALLS"
							class="object-cover size-24 rounded-full shrink-0"
							provider="imagekit"
							:src="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.alt"
						/>
						<img
							v-else
							class="object-contain w-40 max-h-80 rounded-lg"
							:src="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.src"
							:alt="weddingPartyPhotos[getPhotoIndex('Lydia_Gonzalez')!]?.alt"
						>
					</div>
					<span class="font-extralight! text-xl">Lydia Gonzalez</span>
				</div>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Mother</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Lisa_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full text-center justify-center font-extralight! text-xl">Lisa Schmidt</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Father</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Chip_Schmidt')!]?.alt"
					>
				</div>
				<span class="flex w-full text-center justify-center font-extralight! text-xl">Edwin (Chip) Schmidt</span>
			</div>

			<!--			<span class="text-3xl flex w-full justify-center items-center font-semibold! underline underline-offset-4 mt-8">Groom</span> -->
			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-3xl flex w-full justify-center items-center font-semibold! underline underline-offset-4">Groom</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Grant_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Grant Gonzalez</span>
			</div>
			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Best Man</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover size-24 rounded-full shrink-0"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Evan_Bologa')!]?.alt"
					>
				</div>
				<span class="flex w-full justify-center font-extralight! text-xl">Evan Bologa</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Groomsmen</span>
				<div class="flex flex-col items-center justify-center w-full gap-4">
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Joseph_Kirk')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Joe Kirk</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Nick_Swinney')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Nick Swinney</span>
					</div>
					<div class="flex flex-col items-center justify-center gap-1 min-w-30">
						<div
							v-if="!contentLoaded"
							class="size-24 items-center justify-center"
						>
							<LoadingCard
								:show-loading-text="false"
								height="full"
								class="size-24 rounded-full shrink-0"
							/>
						</div>
						<div v-else>
							<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
							<NuxtImg
								v-if="ALLOW_API_CALLS"
								class="object-cover size-24 rounded-full shrink-0"
								provider="imagekit"
								:src="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.alt"
							/>
							<img
								v-else
								class="object-contain w-40 max-h-80 rounded-lg"
								:src="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.src"
								:alt="weddingPartyPhotos[getPhotoIndex('Jack_Gonzalez')!]?.alt"
							>
						</div>
						<span class="font-extralight! text-xl">Jack Gonzalez</span>
					</div>
				</div>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Mother</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Rosie_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex w-full text-center justify-center font-extralight! text-xl">Roselea (Rosie) Gonzalez</span>
			</div>

			<div class="flex flex-col items-center justify-center w-full gap-1">
				<span class="text-2xl flex w-full justify-center font-bold!">Father</span>
				<div
					v-if="!contentLoaded"
					class="size-24 items-center justify-center"
				>
					<LoadingCard
						:show-loading-text="false"
						height="full"
						class="size-24 rounded-full shrink-0"
					/>
				</div>
				<div v-else>
					<!-- Displays each image thumbnail using Nuxt's ImageKit provider -->
					<NuxtImg
						v-if="ALLOW_API_CALLS"
						class="object-cover object-top size-24 rounded-full"
						provider="imagekit"
						:src="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.alt"
					/>
					<img
						v-else
						class="object-contain w-40 max-h-80 rounded-lg"
						:src="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.src"
						:alt="weddingPartyPhotos[getPhotoIndex('Alex_Gonzalez')!]?.alt"
					>
				</div>
				<span class="flex w-full text-center justify-center font-extralight! text-xl">David (Alex) Gonzalez</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import LoadingCard from "~/components/LoadingCard.vue";
	import {
		Divider
	} from "primevue";

	const { ALLOW_API_CALLS } = globalStores();
	const { contentLoaded, weddingPartyPhotos } = imageDataStores();

	const getPhotoIndex = ( photoName: string ) => {
		const photoToDisplay = weddingPartyPhotos.value.find( photo => photo.alt.replace( ".JPG", "" ).replace( ".jpeg", "" ) === photoName ) ??
			weddingPartyPhotos.value.find( photo => photo.alt.replace( ".JPG", "" ).replace( ".jpeg", "" ) === "Default" );
		return photoToDisplay?.index;
	};
</script>

<style scoped>

</style>